import React, { useState } from "react";
import voicepilot from "../../images/voicepilot/voicepilot.png";
import centerstage from "../../images/centerstage/centerstage.png"
import petconnect from "../../images/petconnect/petconnect.png"
import powerplay from "../../images/powerplay/powerplay.png"
import nanogurus from "../../images/nanogurus/nanogurus.png"
import sparksocial from "../../images/sparksocial/sparksocial.png"
import AnimatedList from "../general/animatedlist.tsx";
import HoverText from "../general/hovertext.tsx"
import { engineeringCards } from "../specific_projects/engineeringData.tsx";

function Projects() {
    const [activeIndex, setActiveIndex] = useState(0); // 0 = Engineering, shown by default
    const [reset, setReset] = useState(1); // State to manage reset
   
    const toggleReset = () => {
      setReset(0); // Reset animation
      setTimeout(() => {
        setReset(1); // Ensure reset flag is turned off after triggering
      }, 100); // Small delay to allow reset
    };
    const handleTextClick = (index) => {
      setActiveIndex(index);
      toggleReset();

    };
    document.title = 'Vihas Veggalam | Projects'

    
    const programming_projects = [
        ["VoicePilot", "An innovative way to interact with your computer. Leveraged Google's Gemini to convert natural language to a list of instructions that the computer could do.", voicepilot, "/voicepilot"],
        ["FTC CenterStage", "Helped create and program a robot that earned 1st place Inspire Award at Regional Qualifiers and 2nd place Innovate Award at State Championships.", centerstage, "/ftccenterstage"],
        ["FTC PowerPlay", "Helped create and program a robot that earned 3rd place Inspire Award at Regional Qualifiers and 2nd place Think Award at State Championships.", powerplay, "/ftcpowerplay"],
        ["Virtual Enterprises", "Created the virtual store for PetConnect using Bootstrap, HTML, JavaScript, and Python Flask to host. Uses Google Sheet as a dynamic database to create the site.", petconnect, "/petconnect"],
        ["NanoGurus Website", "Helped create the NanoGurus website using HTML, JavaScript, and Python Flask to host.", nanogurus, "/nanogurus"],
        ["SparkSocial", "Created using React Native and placed 4th Place in FBLA Mobile App Development in the New Jersey Conference.", sparksocial, "/fbla"]
    ]
    const engineering_projects = engineeringCards

    return (
        <>
            <div className="text-center">
                <p className="text-5xl pt-10 font-semibold">My Projects</p>

            </div>
            
            <div className="w-2/3 m-auto">
                <HoverText 
                    text="Engineering"
                    isActive={activeIndex === 0}
                    onClick={() => handleTextClick(0)}
                />
                <HoverText 
                    text="Programming"
                    isActive={activeIndex === 1}
                    onClick={() => handleTextClick(1)}
                />
            </div>
            <AnimatedList items={engineering_projects} active={activeIndex === 0} reset={reset}/>
            <AnimatedList items={programming_projects} active={activeIndex === 1} reset={reset}/>
        </>
    );
}
export default Projects;